export default __webpack_public_path__ + "static/media/2k.0fed48b7.gif";